import { KFDataTable } from "@kf/ic2fx";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../assets/icons/table-arrow.svg";
import { JobPricingReportConstants } from "../../../constants/JobPricingReportConstants";
import { getLanguageCode } from "../../../utilities/helper";
import { PAGE_URL } from "../../../constants/urls.constants";
import {
  JobPricingHeaderDetails,
  JobPricingReportViewBy
} from "../../../helpers/models/JobPricingDetailModels";
import {
  getPricingFiltersThunk,
  updateReportHeaderDetails,
  updateReportViewBy
} from "../../../store/slices/jobPricingDetailsSlice";
import { SJPRListTypes } from "../../../store/slices/jobPricingListSlice";
import { updateJobPricingPayloads } from "../../../store/slices/jobPricingSearchSlice";
import {
  JobPricingListThunk,
  resetSearchKey,
  updatedSearchKey
} from "../../../store/slices/SJPR/listSlice";
import { LoadingOverlay, NoDataListScreen } from "../NoData/ListScreen";

const GradesList = () => {
  const { t } = useTranslation();
  const [gradeList, setGradeList] = useState([]);
  const dispatch = useDispatch();
  const history = useNavigate();
  const { jobPricingList, country } = useSelector((state: any) => {
    return state;
  });
  const getGradesList = (searchKey?: string) => {
    setGradeList([]);
    let updatedFilterPayload: any = { ...jobPricingList?.filters };
    for (const key in updatedFilterPayload) {
      if (updatedFilterPayload[key]?.length === 0) {
        delete updatedFilterPayload[key];
      }
    }
    let data: any;
    if (
      jobPricingList?.searchKey?.length > 0 ||
      (searchKey && searchKey?.length > 0)
    ) {
      data = {
        countryCode: country?.selectedCountry?.key,
        filters: updatedFilterPayload || {},
        language:
          getLanguageCode(),
        search: jobPricingList?.searchKey || searchKey || ""
      };
    } else {
      data = {
        countryCode: country?.selectedCountry?.key,
        filters: updatedFilterPayload || {},
        language:
          getLanguageCode()
      };
    }

    if (jobPricingList?.filters?.customGradeId) {
      data.gradeSetId = jobPricingList.filters.customGradeId;
    }

    if (jobPricingList?.peerGroupId) {
      data.peerGroupId = jobPricingList.peerGroupId;
    }

    const payLoad = {
      category: SJPRListTypes.GRADES,
      data
    };

    dispatch(getPricingFiltersThunk(data));
    dispatch(JobPricingListThunk(payLoad));
  };

  useEffect(() => {
    if (jobPricingList?.filters?.customGradeId !== undefined) {
      const stringSearchKey = sessionStorage.getItem("searchKey") || "";
      stringSearchKey
        ? getGradesList(JSON.parse(stringSearchKey))
        : getGradesList();
    }
  }, [jobPricingList?.filters?.customGradeId]);

  const redirectToReportPricingDetails = (item: any) => {
    dispatch(resetSearchKey());
    sessionStorage.removeItem("searchKey");
    dispatch(updateReportViewBy(JobPricingReportViewBy.GRADE));
    const gradeName = item?.grade
      ? JobPricingReportViewBy.GRADE + " " + item?.grade
      : "";
    const updatedPricingPayloads = {
      searchCategory: JobPricingReportViewBy.GRADE,
      jobKey: "ALL",
      jobOrgCode: "ALL",
      jobName: gradeName,
      jobFamilyName: "ALL",
      jobSubFamilyName: "ALL",
      marketJobFamily: "ALL",
      marketJobSubFamily: "ALL",
      totalJobs: item?.totalJobs || "0",
      jobsInOrg: item?.jobsInOrg || "0",
      gradeId: (item?.grade || "ALL").toString(),
      gradeSpan: "ALL",
      searchTerm: gradeName
    };
    const pricingHeaderDetails = {
      title: gradeName,
      description: "",
      totalJobs: item?.totalJobs || "0",
      orgJobs: item?.jobsInOrg || "0"
    } as JobPricingHeaderDetails;
    dispatch(updateJobPricingPayloads(updatedPricingPayloads));
    dispatch(updateReportHeaderDetails(pricingHeaderDetails));
    history(PAGE_URL.JOB_PRICING_DETAILS);
  };
  useEffect(() => {
    if (jobPricingList?.list?.grades) {
      setGradeList(
        jobPricingList?.list?.grades?.map((item: any) => {
          return {
            ...item,
            id: item?.grade
          };
        })
      );
    } else {
      setGradeList([]);
    }
  }, [jobPricingList?.list?.grades]);
  const GradeListColumns: any = [
    {
      field: "grade",
      headerName: t("pa.grade"),
      flex: 4,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: "totalJobs",
      headerName: t("pa.headerTotalJobs"),
      flex: 2,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: "jobsInOrg",
      headerName: t("pa.headerJobsInOrg"),
      sortable: false,
      disableColumnMenu: true,
      flex: 2
    },
    {
      field: "incumbents",
      headerName: t("pa.sjpr.incumbents"),
      sortable: false,
      disableColumnMenu: true,
      flex: 2
    },
    {
      field: "",
      headerName: " ",
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      renderCell: () => {
        return (
          <div>
            <img src={Arrow} alt="Details icon" />
          </div>
        );
      }
    }
  ];
  return (
    <div
      className={`app-table ${
        jobPricingList?.isListloading || gradeList.length === 0
          ? "grid-overlay-height"
          : ""
      }`}
    >
      <KFDataTable
        sx={{
          "& .MuiDataGrid-cell:hover": {
            cursor: "pointer"
          },
          "& .kfic2-button.MuiIconButton-root.kfic2-ghostSecondary:focus, & .kfic2-button.MuiIconButton-root.kfic2-ghostSecondary:hover, & .kfic2-button.MuiIconButton-root.kfic2-ghostSecondary, & .kfic2-button.MuiIconButton-root.kfic2-ghostSecondary:active ":
            {
              color: "var(--button-text)",
              borderColor: "var(--button-text)"
            },
          "& .css-i4bv87-MuiSvgIcon-root": {
            fill: "var(--button-text)"
          }
        }}
        paginationLabel={{
          "Items per page:": t("pa.pagination.itemsPerPage"),
          of: t("pa.pagination.of"),
          items: t("pa.pagination.items"),
          "more than": t("pa.pagination.moreThan"),
          page: t("pa.pagination.page"),
          pages: t("pa.pagination.pages")
        }}
        rowsPerPageOptions={
          JobPricingReportConstants.TABLE_ROWS_PER_PAGE_OPTIONS
        }
        sortingOrder={JobPricingReportConstants.TABLE_SORTING_ORDER}
        initialState={{
          pagination: {
            pageSize: JobPricingReportConstants.TABLE_DEFAULT_PAGE_SIZE
          }
        }}
        rows={gradeList}
        columns={GradeListColumns}
        loading={jobPricingList?.isListloading}
        onCellClick={(params: any, event, details) => {
          redirectToReportPricingDetails(params.row);
        }}
        components={{
          NoRowsOverlay: () => <NoDataListScreen />,
          LoadingOverlay: () => <LoadingOverlay columsList={GradeListColumns} />
        }}
      />
    </div>
  );
};

export default GradesList;
